class StudioMenu extends HTMLElement {
  constructor() {
    super();
    this.anchors = null;
    this.studioMenu = null;
    this.htmlContent = '';
  }

  connectedCallback() {
    this.anchors = document.querySelectorAll('[data-anchorname]');
    this.studioMenu = document.querySelector('studio-menu');
    this.htmlContent = '';

    Array.from(this.anchors).forEach((anchor) => {
      const name = anchor.getAttribute('data-anchorname');
      const id = anchor.id;
      this.htmlContent += `<a href="#${id}">${name}</a>`;
    });

    this.studioMenu.innerHTML = this.htmlContent;
  }
}

if (!customElements.get('studio-menu')) {
  customElements.define('studio-menu', StudioMenu);
}
